module.exports = __webpack_public_path__ + "actor2.png?6d72fb03029fe07faeea0e2c954e4cc1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/actor2.png
// module id = 58
// module chunks = 0